export const GET_FORM_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    formBlock(id: "${id}", preview: ${preview}) {
    sys {
        id
      }
      name
      formId
      formTitle
      formDescription
      simpleNewsletterVersion
    }
  }
`;
